<template>
  <div class = "container-fluid">
    <header>
      <img class = "img100" src = "https://test.facejournal.cn/tm_0cfc4116fa5c24cddbb1e5c688ea699c_20220126145618.jpg"/>
    </header>
    <section>
      <img class = "imgtit" src = "https://test.facejournal.cn/tm_a13f7e812faa71afcb13e885be6f1eee_20220126143313.jpg"/>
      <!--      <h3 class = "swiper-tit">你的成功需要他人的经验</h3>-->

      <h3 class = "swiper-tit">你的成功需要他人的经验</h3>
      <div class = "swiper-container swiper-swordclass">
        <div class = "swiper-wrapper">
          <div class = "swiper-slide" v-for = "(item,index) in swordclassVideo" :key = "index"
               :data-url = "item.videoUrl" :data-img = "item.videoImg">
            <img :src = "item.videoImg"/>
            <div class = "playstart">
              <van-icon name = "play-circle-o" size = "0.64rem" color = "#ffffff"/>
            </div>
          </div>
        </div>
        <div class = "swiper-pagination"></div>
      </div>

      <h3 class = "swiper-tit">科研工匠</h3>
      <div class = "swiper-container swiper-sectionstudy">
        <div class = "swiper-wrapper">
          <div class = "swiper-slide" v-for = "(item,index) in sectionstudyVideo" :key = "index"
               :data-url = "item.videoUrl" :data-img = "item.videoImg">
            <img :src = "item.videoImg"/>
            <div class = "playstart">
              <van-icon name = "play-circle-o" size = "0.64rem" color = "#ffffff"/>
            </div>
          </div>
        </div>
        <div class = "swiper-pagination"></div>
      </div>

      <h3 class = "swiper-tit">编辑讲座</h3>
      <div class = "swiper-container swiper-editVideo">
        <div class = "swiper-wrapper">
          <div class = "swiper-slide" v-for = "(item,index) in editVideo" :key = "index" :data-url = "item.videoUrl"
               :data-img = "item.videoImg">
            <img :src = "item.videoImg"/>
            <div class = "playstart">
              <van-icon name = "play-circle-o" size = "0.64rem" color = "#ffffff"/>
            </div>
          </div>
        </div>
        <div class = "swiper-pagination"></div>
      </div>

      <img class = "imgtit" src = "https://test.facejournal.cn/tm_61bc3a7312c95c4c72422ef0dcb0e4c5_20220126143417.jpg"/>
      <img class = "img100" src = "https://test.facejournal.cn/tm_288c390d5a7180796fec3b77a037a13f_20220126145935.jpg"/>
      <ul class = "footer-erwm">
        <li>
          <img src = "https://test.facejournal.cn/tm_3a54938c1be5b49eed10c20e63e38ce4_20220125093751.jpg"/>
          <p>小程序</p>
          <!-- <p>请扫描二维码查看更多</p> -->
        </li>
        <li>
          <img src = "https://www.keyanxiezuo.com/static/index/images/scien-res.jpg"/>
          <p>公众号</p>
          <!-- <p>请扫描二维码查看更多</p> -->
        </li>
        <li>
          <img src = "http://test.facejournal.cn/tm_8a7c82c378c4eebaee32e4e45147effd_20220110144636.png"/>
          <p>人工客服</p>
          <!-- <p>扫描二维码联系客服</p> -->
        </li>

      </ul>
    </section>
    <div class = "vip-button">
      <van-button round type = "primary" @click = "payVip">开通会员</van-button>
      <van-button type = "primary" @click = "receiveVip">会员免费领取</van-button>
      <van-button type = "primary" @click = "vipShare">邀请好友</van-button>
      <van-button round type = "primary" @click = "freeVip">免费体验7天</van-button>
    </div>

    <van-dialog class = "vip-dialog" v-model = "dialogShow" :show-cancel-button = "true" cancel-button-text = "关闭"
                :show-confirm-button = "false">
      <img id = 'hb' src alt = "">
      <p>长按保存发送好友<br>每邀请一位新用户，会员有效期自动延长2天</p>
    </van-dialog>

    <div class = "free-vip-popup" v-if = "freevipshow">
      <div class = "free-vip">
        <span class = "close-free" @click = "closefree"><van-icon size = "24px" name = "cross"/></span>
        <van-cell-group>
          <van-field v-model = "telPhone" label = "手机号" placeholder = "请输入手机号码"/>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model = "telCode"
            center
            clearable
            label = "验证码"
            placeholder = "请输入短信验证码"
          >
            <template #button>
              <van-button v-if = "iftelCode" size = "small" type = "primary" @click = "captchaClick">获取验证码</van-button>
              <van-button v-else size = "small" type = "primary" disabled>{{ authTime }}s后重新发送验证码</van-button>
            </template>
          </van-field>
        </van-cell-group>
        <van-button round type = "primary" class = "bindphone" @click = "bindphone">确定</van-button>
      </div>

    </div>

    <div class = "marks" v-show = "dplayerDialogShow">
      <van-icon class = "marks-cross" name = "cross" @click = "closeDplayer"/>
    </div>
    <div id = "dplayer" v-show = "dplayerDialogShow" class = "dplayer-dialog"></div>

    <van-dialog class = "sussce-vip-dialog" title = "您已购买成功,请扫码关注" v-model = "dialogSussceShow"
                :show-cancel-button = "true" cancel-button-text = "关闭" :show-confirm-button = "false">
      <ul class = "footer-erwm">
        <li>
          <img src = "https://test.facejournal.cn/tm_3a54938c1be5b49eed10c20e63e38ce4_20220125093751.jpg"/>
          <p>悟空科研小程序</p>
          <p>请扫描二维码查看更多</p>
        </li>
        <li>
          <img src = "https://www.keyanxiezuo.com/static/index/images/scien-res.jpg"/>
          <p>科研写作研究所</p>
          <p>请扫描二维码查看更多</p>
        </li>
      </ul>
    </van-dialog>

    <!--加载loading-->
    <div class = "loadling-box" v-if = "loadingShow">
      <van-loading type = "spinner"/>
    </div>

    <!--  客户分享弹出营销二维码  -->
    <van-dialog class = "market-QRcode-dialog" title = " " v-model = "dialogmarketQRcodeShow"
                :show-cancel-button = "true" cancel-button-text = "关闭" :show-confirm-button = "false">
      <div class = "QRcode-area">
        <img width = "220px" :src = "baseQRcodeSrc"/>
        <p>扫码联系客服</p>
      </div>
    </van-dialog>

    <!--已开通会员弹窗-->
    <van-dialog class = "vip-dialog" v-model = "openVipDialogShow" :show-cancel-button = "true" cancel-button-text = "关闭"
                :show-confirm-button = "false">
      <p>{{openVipTipsContent}}</p>
    </van-dialog>

  </div>
</template>


<script>
import Vue from 'vue';
import {Field, Icon, Checkbox, CheckboxGroup, CountDown, Notify, Dialog, Loading} from 'vant';

Vue.use(Icon);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CountDown);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Loading);
import '../assets/swiperslide/swiper.min.css';
import Swiper from 'swiper';
import DPlayer from 'dplayer';
import QRcode from 'qrcodejs2';
import sdk from '../utlis/shareWx'; //微信分享
import {authUrl} from '../api/auth_http'
import {ticketApi,getSMS,bindPhone} from '../api/auth_api'
import {openTryCard,getQrCode,openCountCard,isShowButton,createPerson,IsPerson,getCode} from '../api/index'
export default {
  name: 'index',
  components:{},
  data() {
    return {
      buttonType: 0,
      openVipGgid: '',
      dialogmarketQRcodeShow: false,
      baseQRcodeSrc: '', // 弹窗二维码
      DebaseQRcodeSrc: 'data:image/png;base64,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',// 默认弹窗二维码
      openVipDialogShow: false,//您的会员已开通
      openVipTipsContent: '',
      banData: [],
      telPhone: '',
      telCode: '',
      iftelCode: true,
      checked: true,
      sms: '',
      time: 5 * 60 * 1000,
      freevipshow: false,
      ifplaystart: true,
      dialogShow: false,
      ticketGet: '',//获取ticket
      webUrl: '',//网站链接
      dp: null,
      dplayerDialogShow: false,
      dialogSussceShow: false,
      authTime: 0,
      hb: '', //海报
      loadingShow: false,
      // 科研工匠
      sectionstudyVideo: [
        {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e811194c387702295250345153/PaJA3YjpY7EA.mp4?t=1894615074&exper=0&rlimit=&us=SnkhilCCX1OUpzyp&sign=0bfd3874005817966a9ce5f18ca4a895',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/kstyt8nh0j4m.jpg'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e365b32a387702295250143227/qDiFqnmmLSAA.mp4?t=1894615074&exper=0&rlimit=&us=R48UZUPQFmhk23NY&sign=4a4a6f8197be3e92c549d480e952b5ad',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/ku8ia7u80uh8.png'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e5e25353387702295250269164/9ArmXtCWY6sA.mp4?t=1894615074&exper=0&rlimit=&us=TACwYggEZzgeCM9H&sign=e0f004ce8a89f3e0b2766f07daf45026',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kuxsjmsz0uoa.jpg'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e5be3fb2387702295250249831/uunw7trhcxYA.mp4?t=1894615074&exper=0&rlimit=&us=XMzz5vEQ8V0MP96D&sign=aa3d0910ecb692502d5ee16103858bf2',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kw606gyq0l0x.png'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e5cd9298387702295250254697/RcAQLkAopRsA.mp4?t=1894615074&exper=0&rlimit=&us=UuTKbFmtTlIJtrlt&sign=a30dacbf1bd55edccdd07be7acce7b34',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/ky1cfz0h0o85.jpg'
        }
      ],
      // 编辑讲座
      editVideo: [
        {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e5e1ceef387702295250268323/KGnLzC3bNVcA.mp4?t=1894615074&exper=0&rlimit=&us=QP8K7VVibhjbvKz2&sign=a120a3444c891b66831a974da8e65d90',
          videoImg: 'http://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kmn53tv00erj.jpg'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e8111dd0387702295250345274/TvFI0w6S0DkA.mp4?t=1894615074&exper=0&rlimit=&us=G92AXc0NdGaFjolg&sign=9e056746785e2c4a4b03201ba2a7202d',
          videoImg: 'http://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/kce6796m041xer3wsdze.png'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e365c82f387702295250143709/dyR23VjavRcA.mp4?t=1894615074&exper=0&rlimit=&us=s8uoTYfMwFt2UkZq&sign=6774fc04923de36d7653bef283b5fbcc',
          videoImg: 'http://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/krod68gl06oq.png'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e810a6fa387702295250344798/OrSXwNal5doA.mp4?t=1894615074&exper=0&rlimit=&us=82GsfOxxLSxF0ltC&sign=2c04101601880586b1c564f525e5bdb8',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kulzqswk0ac5.jpg'
        }, {
          videoUrl: 'http://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/e613adae387702295250290183/oCa2yEYmvhkA.mp4?t=1894615074&exper=0&rlimit=&us=nFubH1ouaDMTMkff&sign=167e37b039d8e6d0099adc80db925806',
          videoImg: 'https://wechatapppro-1252524126.file.myqcloud.com/appzissbssa6278/image/b_u_6170d73860ce7_73CZtcAY/kyjkl2s30gkm.png'
        }
      ],
      // 三剑课
      swordclassVideo: [
        {
          videoUrl: 'https://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/18b6e573387702295206354069/wk7OU6NlP50A.mp4?t=1894615074&exper=0&rlimit=&us=Ijsqg05rsNIHRWtw&sign=e735089c1b5ee3c3ebfe07239adbf806',
          videoImg: 'https://wechatapppro-1252524126.cdn.xiaoeknow.com/appzissbssa6278/image/b_u_6170d73860ce7_73CZtcAY/kyav4bts0bx8.jpg'
        }, {
          videoUrl: 'https://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/1fd85e2e387702295206670018/aYAJrjmxIQAA.mp4?t=1894615074&exper=0&rlimit=&us=46jjHD9bzdedcsCv&sign=b103ef500a92a306165fa75049cb9837',
          videoImg: 'https://wechatapppro-1252524126.cdn.xiaoeknow.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kxrakp45087e.png'
        }, {
          videoUrl: 'https://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/1daa29b5387702295206595190/lfKX8ov2aawA.mp4?t=1894615074&exper=0&rlimit=&us=ZLlobgZiYYqsC54O&sign=e4fa6938ffb5e43eb95b39f06a8c7646',
          videoImg: 'https://wechatapppro-1252524126.cdn.xiaoeknow.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kxrapx9801cx.png'
        }, {
          videoUrl: 'https://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/21d709b7387702295206727951/kVTipA84zMEA.mp4?t=1894615074&exper=0&rlimit=&us=iRxyr1cjUFNBAz0o&sign=84908d2c2878f9a26d40989176e4d220',
          videoImg: 'https://wechatapppro-1252524126.cdn.xiaoeknow.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kxrakp45087e.png'
        }, {
          videoUrl: 'https://1304109277.vod2.myqcloud.com/e365511cvodbj1304109277/1daa39b2387702295206595511/vMI6MPEAkeYA.mp4?t=1894615074&exper=0&rlimit=&us=be9wVo1HpIdhqTch&sign=ca03d93c688c060335a3e8e18671b63c',
          videoImg: 'https://wechatapppro-1252524126.cdn.xiaoeknow.com/appzissbssa6278/image/b_u_5e7c68644c02f_Gf82tt7f/kxrapx9801cx.png'
        }
      ]
    };
  },
  created() {
    let ccidQuery = this.$route.query.ccid  //ccid---客服id
    let ggidQuery = this.$route.query.ggid  //ggid---核销码
    let personQuery = this.$route.query.person  //person---销售
    this.webUrl = 'https://vip2022.wukongkeyan.com' + '/#/' + '?ccid=' + ccidQuery + '&ggid=' + ggidQuery + '&person=' + personQuery
    this.ticketGet = authUrl + '/login?app=member_activity&target=' + encodeURIComponent(this.webUrl)
    let thisUrl = window.location.href;
    if (thisUrl.indexOf('st=ok') != -1) {
      this.dialogSussceShow = true;
      setTimeout(function () {
        window.location.href = this.webUrl;
      }, 4000);
    } else if(thisUrl.indexOf('st=cancel') != -1){
      window.location.href = this.webUrl;
    }
    let tcode = this.$route.query.tcode;
    let lotcode = window.localStorage.getItem('tcode');

    if (tcode && (lotcode == undefined || lotcode == 'null')) {
      window.localStorage.setItem('tcode', tcode);
    }

    let ccid = this.$route.query.ccid;//客服id
    let ggid = this.$route.query.ggid;//核销码
    let ex = window.localStorage.getItem('expires');
    let token = window.localStorage.getItem('token');
    if (token != null) {
      let datanews = (new Date()).getTime();
      let ext = (new Date(ex)).getTime();
      if (ext < datanews) {
        this.wechatLogin()
      }
      this.IsPerson()
      if ((ccid != null || ccid != undefined) && (ggid != null || ggid != undefined)) {
        this.isShowButton(ccid, ggid);
      }
    } else {
      this.wechatLogin()
    }
  },
  mounted() {
    let that = this;
    new Swiper('.swiper-swordclass', {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        click: function (v) {
          var url = v.clickedSlide.attributes['data-url'].nodeValue;
          var img = v.clickedSlide.attributes['data-img'].value;
          that.clickPlay(url, img);
        },
      }
    });

    new Swiper('.swiper-sectionstudy', {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        click: function (v) {
          var url = v.clickedSlide.attributes['data-url'].nodeValue;
          var img = v.clickedSlide.attributes['data-img'].value;
          that.clickPlay(url, img);
        },
      }
    });
    new Swiper('.swiper-editVideo', {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        click: function (v) {
          var url = v.clickedSlide.attributes['data-url'].nodeValue;
          var img = v.clickedSlide.attributes['data-img'].value;
          that.clickPlay(url, img);
        },
      }
    });
  },
  methods: {
    //分享朋友圈
    share(str) {
      let shareurl = location.href
      let dataForWeixin = {
        title: '悟空科研：您的专属科研筋斗云', //分享标题
        desc: '', //分享内容
        linkurl: 'https://vip2022.wukongkeyan.com' + '/#/' + str, //公众号下的域名 分享链接
        img: 'https://test.facejournal.cn/tm_c3f9558d681bac963339b7c69894c4f7_20220126152005.png' //分享内容显示的图片(图片必须是正方形的链接)
      }
      sdk.getJSSDK(shareurl,dataForWeixin);
    },

    // 会员免费领取
    receiveVip() {
      if (this.buttonType == 0) {
        this.showAlertQRCode();
      } else {
        let ggid = this.openVipGgid;
        if (ggid == null || ggid == undefined || ggid == '') {
          Notify({type: 'warning', message: '非法请求'});
          return;
        }
        let getItemPhone = window.localStorage.getItem('isPerfectPhone');
        if (getItemPhone == 'true') {
          this.openCountCard(ggid);
        } else {
          this.freevipshow = true;
        }
      }
    },

    //专属码为空替换为默认码
    showAlertQRCode() {
      if (this.baseQRcodeSrc === '') {
        this.baseQRcodeSrc = this.DebaseQRcodeSrc;
      }
      this.dialogmarketQRcodeShow = true;
    },

    // 开通3个月会员
    openCountCard(ggid) {
      openCountCard(ggid).then(res=>{
        if (res.data.code == 1) {
          this.openVipTipsContent = '您的会员已开通'
          this.openVipDialogShow = true;
        } else {
          this.openVipDialogShow = true;
          this.openVipTipsContent = res.data.msg
        }
      })
    },

    //是否领取3个月会员按钮显示
    isShowButton(person, code) {
      let params = {
        code: code,
        person_id: parseInt(person)
      };
      isShowButton(params).then(resall=>{
        let resdata = resall.data;
        if (resdata.code == 1) {
          if (resdata.data.res.is_person) {
            this.buttonType = 0;
          } else {
            this.buttonType = resdata.data.res.btn_type;
            this.openVipGgid = resdata.data.res.ggid;
            this.kfQRcode(resdata.data.res.root_id)
          }
        }
      })
    },
    // 客服二维码
    kfQRcode(ccid) {
      getQrCode(ccid).then(res=>{
        if (res.data.code == 1) {
          this.baseQRcodeSrc = res.data.data.codeStr; // 专属码
        }
      })
    },

    //是否为营销人员
    IsPerson() {
      createPerson() //收集销售信息/创建销售人员方法
      IsPerson().then(res=>{
        let resdata = res.data;
        if (resdata.code == 1) {
          let str = '?ccid=' + resdata.data.person.id + '&ggid=' + resdata.data.codeInfo.code;
          this.share(str);
        }
      })
    },

    //VIP分享
    vipShare() {
      let getItemPhone = window.localStorage.getItem('isPerfectPhone');
      if (getItemPhone == 'true') {
        this.loadingShow = true;
        let usercode = window.localStorage.getItem('usercode');
        if (!usercode) {
          this.getCode();
        }
        setTimeout(() => {
          let usercode = window.localStorage.getItem('usercode');
          let userName = window.localStorage.getItem('userName');
          if (userName == null) {
            userName = '';
          }
          let qdiv = document.createElement('div');
          let qr = new QRcode(qdiv, {
            text: 'https://vip2022.wukongkeyan.com/#/?tcode=' + usercode,//二维码内容，可以为一个链接
            width: 120,//宽度
            height: 120,//高度
            correctLevel: 3//容错级别
          });
          //console.log(qdiv);
          let codeImg = qdiv.getElementsByTagName('canvas')[0];
          //console.log(codeImg);
          let canvas = document.createElement('canvas');
          let context = canvas.getContext('2d');
          let BG = new Image();
          BG.crossOrigin = 'anonymous';
          BG.onload = function () {
            canvas.width = 834;
            canvas.height = 879;
            context.drawImage(this, 0, 0);
            context.getImageData(0, 0, this.width, this.height);
            context.drawImage(codeImg, 686, 740, 120, 120);
            context.fillStyle = '666';   // 文字填充颜色
            context.font = '28px  SC';
            context.fillText(userName, 35, 780);  //文字
            let base64 = canvas.toDataURL();
//            console.log('sss',base64)
            document.getElementById('hb').setAttribute('src', base64);
//            this.hb = base64
          };
          BG.src = 'https://test.facejournal.cn/tm_dbcce9499a7cc2e73504f05276246a35_20220126143536.jpg';
          this.dialogShow = true;
          this.loadingShow = false;
        }, 2000);
      } else {
        this.freevipshow = true;
      }
    },

    // 关闭播放视频
    closeDplayer() {
      this.dplayerDialogShow = false;
      this.dp.destroy();
    },
    //点击播放视频
    clickPlay(videoUrl, videoImg) {
      let that = this;
      console.log(videoUrl, videoImg);
      that.dp = new DPlayer({
        container: document.getElementById('dplayer'),
        autoplay: true,
        video: {
          url: videoUrl,
          pic: videoImg
        },
      });
      this.dplayerDialogShow = true;
    },

    //跳转微信支付
    payVip() {
      let webUrlArr = this.webUrl.split('/#/')
      let getItemInfo = window.localStorage.getItem('bindInfo');
      if(getItemInfo == 'true'){
        let getItemPhone = window.localStorage.getItem('isPerfectPhone');
        if (getItemPhone == 'true') {
          let usercode = window.localStorage.getItem('usercode');
          if (!usercode) {
            this.getCode();
          }
          setTimeout(() => {
            this.$router.push({
              path: '/pay' + webUrlArr[1]
            });
          }, 500);
        } else {
          this.freevipshow = true;
        }
      } else {
        let ticketArr = this.ticketGet.split('?')
        let ticketGet = ticketArr[0] + '?code=info&' + ticketArr[1]
        window.location.href = ticketGet
      }
    },

    // 获取邀请码
    getCode() {
      let lotcode = window.localStorage.getItem('tcode');
      getCode(lotcode).then(res=>{
        if (res.data.code == 1) {
          window.localStorage.setItem('usercode', res.data.data.code);
          window.localStorage.setItem('userName', res.data.data.userName);
        }
      })
    },

    // 免费体验—弹窗
    freeVip() {
      let getItemPhone = window.localStorage.getItem('isPerfectPhone');
      if (getItemPhone == 'true') {
        let usercode = window.localStorage.getItem('usercode');
        if (!usercode) {
          this.getCode();
        }
        setTimeout(() => {
          this.openTryCard();
        }, 500);
      } else {
        this.freevipshow = true;
      }
    },

    //免费试用
    openTryCard() {
      openTryCard().then(res=>{
        if (res.data.code == 1) {
          Notify({type: 'success', message: '您已试用成功'});
        } else {
          Notify({type: 'warning', message: res.data.msg});
        }
        if (res.data.code == 401) {
          this.wechatLogin();
        }
      })
    },

    //微信登录
    wechatLogin() {
      let ticket = this.$route.query.ticket
      if (ticket != undefined) {
        let data = {
          key: ticket
        }
        ticketApi(data).then(res=>{
          if (res.data.code == 0) {
            window.localStorage.setItem('expires', res.data.data.expire);
            window.localStorage.setItem('isPerfectPhone', res.data.data.phone);
            window.localStorage.setItem('bindInfo', res.data.data.info);
            window.localStorage.setItem('token', res.data.data.token);
            //ccid---客服id    //ggid---核销码    //person---销售
            window.location.href = window.location.protocol + '//' + window.location.host + '/#/bounce_back?ccid=' + this.$route.query.ccid + '&ggid=' + this.$route.query.ggid + '&person=' + this.$route.query.person
          } else {
            window.location.href = this.ticketGet
          }
        })
      } else {
        let token = window.localStorage.getItem('token')
        if(token == null){
          window.location.href = this.ticketGet
        }
      }
    },

    //绑定手机号—获取验证码
    captchaClick() {
      if (this.telPhone != '') {
        if (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.telPhone)) {
          let data = {
            phone: this.telPhone
          }
          getSMS(data).then(res=>{
            if (res.data.code == 0) {
              this.setAuthTime();
              this.iftelCode = false;
            } else if (res.data.code == 2) {
              Notify({type: 'warning', message: res.data.msg});
            }
          })
        } else {
          Notify('请输入正确的手机号码');
        }
      } else {
        Notify({type: 'warning', message: '请输入手机号'});
      }
    },
    // 获取验证码倒计时
    setAuthTime() {
      this.authTime = 300;
      let authTimer = setInterval(() => {
        this.authTime--;
        if (this.authTime <= 0) {
          this.iftelCode = true;
          clearInterval(authTimer);
        }
      }, 1000);
    },

    // 免费体验—绑定手机号
    bindphone() {
      let data = {
        phone: this.telPhone,
        code: this.telCode
      };

      if (this.telPhone.length != 11 || this.telCode.length != 6) {
        Notify({
          message: '输入有误',
          duration: 4000
        });
        return;
      }
      bindPhone(data).then(res=>{
        if (res.data.code == 0) {
          window.localStorage.setItem('expires', res.data.data.token.expire);
          window.localStorage.setItem('token', res.data.data.token.token);
          window.localStorage.setItem('isPerfectPhone', res.data.data.token.phone);
          Notify({
            message: '您已成功绑定手机号码',
            duration: 2500
          });
          this.freevipshow = false;
        } else {
          Notify({
            message: '无效验证码',
            duration: 4000
          });
        }
      })
    },

    // 关闭弹窗
    closefree() {
      this.freevipshow = false;
    }
  }
};
</script>


<style scoped>
.loadling-box {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.van-loading {
  font-size: 0.64rem;
}

.van-dialog {
  border-radius: 0.08rem;
}

.sussce-vip-dialog .footer-erwm {
  margin-bottom: 0.32rem;
}

.footer-erwm {
  margin-top: 0.32rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.footer-erwm img {
  width: 1.96rem;
  height: auto;
}

.footer-erwm p {
  margin: 0;
  margin-top: 0.08rem;
  font-size: 0.24rem;
  color: #070707;
  text-align: center;
}

.dplayer-dialog {
  width: 90%;
  border: 0.16rem solid #fff;
  border-radius: 0.08rem;
  position: fixed;
  top: 24%;
  left: calc(5% - 0.16rem);
  z-index: 20;
}

.marks {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 18;
}

.marks-cross {
  width: .64rem;
  height: .64rem;
  line-height: .64rem;
  text-align: center;
  color: #fff;
  font-size: 0.48rem;
  border: .04rem solid #fff;
  border-radius: 50%;
  position: absolute;
  right: 0.16rem;
  top: 0.16rem;
}

.vip-dialog {
  width: 90%;
  overflow: hidden;
}

.vip-dialog p {
  padding: 0 0.16rem;
  text-align: center;
  font-size: 0.28rem;
  font-weight: 500;
  color: #795548;
}

.vip-dialog img {
  width: 100%;
  height: auto;
}

.free-vip-popup {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.15);
  padding: 0 0.56rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.free-vip {
  padding: 0.8rem 0 0.4rem;
  background: #fff;
  border-radius: 0.08rem;
  position: relative;
}

.close-free {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem
}

.bindphone {
  width: 50%;
  margin-top: 0.24rem;
}

.free-vip-popup >>> .van-field__label {
  width: 3.2em;
  line-height: 0.72rem;
}

.free-vip-popup >>> .van-field__control {
  height: 0.72rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-indent: 0.1rem;
}

.free-vip-popup >>> .van-button--primary {
  height: 0.72rem;
  font-size: 0.28rem;
  background: #fdd000;
  border: 0;
}

.free-vip-popup >>> [class*=van-hairline]::after {
  border: 0;
}

.container-fluid {
  padding-bottom: 1.24rem;
}

.container-fluid .img100 {
  width: 100%;
  height: auto;
}

.imgtit {
  display: block;
  width: 90%;
  margin: 0.1rem auto;
}

.vip-button {
  width: 100%;
  position: fixed;
  bottom: 0.08rem;
  left: 0;
  z-index: 200;
}

.swiper-tit {
  display: inline-block;
  margin-top: 0;
  font-size: 0.32rem;
  text-align: center;
  color: #7b4e24;
  position: relative;
  z-index: 2;
}

.swiper-tit:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 0.1rem;
  background-color: #ffdc3c;
}

.vip-button .van-button {
  /*width: calc(33.333333% - 0.48rem);*/
  width: auto;
  margin: 0 auto;
  color: #fff;
  border: 0;
  flex: 1;
}

.vip-button .van-button:first-child {
  border-radius: 0.4rem 0 0 0.4rem;
  background: linear-gradient(90deg, #d8aa69, #dcb06c);
}

.vip-button .van-button:nth-child(2) {
  border-radius: 0;
  background: linear-gradient(90deg, #dcb06c, #bb985f);
}

.vip-button .van-button:nth-child(3) {
  border-radius: 0;
  background: linear-gradient(90deg, #bb985f, #3a332a);
}

.vip-button .van-button:last-child {
  border-radius: 0 0.4rem 0.4rem 0;
  background: linear-gradient(90deg, #3a332a, #2a1e07);
}

.swiper-container {
  width: 100%;
  height: 100%;
  margin-bottom: 0.4rem;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
  position: relative;
}

.swiper-slide-active, .swiper-slide-duplicate-active {
  transform: scale(1);
}

.swiper-slide img {
  width: 100%;
  height: auto;
  box-shadow: 0 0 0.08rem rgba(0, 0, 0, 0.4);
}

.playstart {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/*.swiper-slide .van-icon{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}*/
</style>



// WEBPACK FOOTER //
// src/views/index.vue